import clsx from 'clsx';
import styles from './AboutUsSplitHero.module.css';

interface Props {
  imagePath: string;
  imageAlt: string;
  children: JSX.Element | JSX.Element[];
  background?: 'tealGradient' | 'transparent' | 'white';
  /** Whether to add a reduced amount of vertical padding */
  withReducedPadding?: boolean;
  /** Height of hero on mobile, default large */
  mobileHeroHeight?: 'small' | 'large';
  /** Whether to add extended padding below component, to be used in connecting inner component adding overlapAbove */
  extendBackgroundBelow?: boolean;
  imageSwitchSide?: boolean;
  imageContainerAbove?: boolean;
}

const AboutUsSplitHero = ({
  imageAlt,
  imagePath,
  children,
  background = 'tealGradient',
  withReducedPadding,
  mobileHeroHeight = 'large',
  extendBackgroundBelow,
  imageSwitchSide,
  imageContainerAbove,
}: Props) => (
  <div
    className={clsx(styles.container, imageSwitchSide ? styles.imageRight : '')}
  >
    <div
      className={clsx(
        styles.imageContainer,
        imageContainerAbove ? styles.imageContainerAbove : '',
      )}
    >
      <img
        className={clsx(
          styles.image,
          styles['mobileHeroHeight__' + mobileHeroHeight],
        )}
        src={imagePath}
        alt={imageAlt}
      />
    </div>
    <div
      className={clsx(
        styles.textContainer,
        styles['background__' + background],
        withReducedPadding ? styles.withReducedPadding : '',
      )}
    >
      <div
        className={clsx(
          extendBackgroundBelow ? styles.extendBackgroundBelow : '',
        )}
      >
        <div className={clsx(styles.textContainerInner)}>{children}</div>
      </div>
    </div>
  </div>
);

export default AboutUsSplitHero;
